import React from 'react';
import { useTranslation } from 'react-i18next';
import { Visibility, Print, Download, Email } from '@mui/icons-material';
import { Chip, Box, Typography } from '@mui/material';
import AuditTimeline, { AUDIT_LOG_STATUS } from '@/components/AuditTimeline';
import { useGetECheckAuditLogs } from '@/api/hooks/refunds';

const ECHECK_ACTION_CONFIG = {
  view: {
    icon: Visibility,
    color: 'info',
    labelKey: 'eCheckAudit.actions.view',
    defaultLabel: 'View',
  },
  print: {
    icon: Print,
    color: 'secondary',
    labelKey: 'eCheckAudit.actions.print',
    defaultLabel: 'Print',
  },
  download: {
    icon: Download,
    color: 'success',
    labelKey: 'eCheckAudit.actions.download',
    defaultLabel: 'Download',
  },
  email: {
    icon: Email,
    color: 'warning',
    labelKey: 'eCheckAudit.actions.email',
    defaultLabel: 'Email',
  },
};

const ECheckAuditTimeline = ({ transactionId }) => {
  const { t } = useTranslation();
  const { auditLogs, loading, error } = useGetECheckAuditLogs(transactionId);

  const renderExtra = (item) => {
    if (item.status !== AUDIT_LOG_STATUS.DENIED) return null;

    const permissionChild = item.metadata?.permission?.childTitle;
    const permissionAction = item.metadata?.permission?.action;
    const failureReason = item.metadata?.failureReason;

    if (!permissionChild && !permissionAction && !failureReason) return null;

    return (
      <Box sx={{ mt: 1, pr: 2 }}>
        {failureReason && (
          <Typography
            variant='caption'
            color='error.main'
            sx={{ mb: 1, display: 'block', fontSize: '0.7rem' }}>
            {failureReason}
          </Typography>
        )}
        {(permissionChild || permissionAction) && (
          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            {permissionChild && (
              <Chip
                label={permissionChild}
                size='small'
                color='error'
                variant='outlined'
              />
            )}
            {permissionAction && (
              <Chip
                label={permissionAction}
                size='small'
                color='error'
                variant='outlined'
              />
            )}
          </Box>
        )}
      </Box>
    );
  };

  return (
    <AuditTimeline
      logs={auditLogs}
      loading={loading}
      error={error}
      actionConfig={ECHECK_ACTION_CONFIG}
      emptyMessage={t('eCheckAudit.empty', 'No eCheck activity yet')}
      renderExtra={renderExtra}
    />
  );
};

export default ECheckAuditTimeline;
